const kovButtonOnClick = 'onClick';

class KovJumboButton {
  constructor($scope) {
    'ngInject';

    this.$scope = $scope;
  }

  $onInit() {
    this.sDisabled = this.sDisabled || false;
  }

  onClick() {
    this.$scope.$emit(kovButtonOnClick, this.sId);
  }
}

module.exports = {
  template: require('./kovJumboButton.html'),
  controllerAs: 'ctrl',
  controller: KovJumboButton,
  transclude: true,
  bindings: {
    sId: '@?',
    sDisabled: '<',
    sTopIcon: '@',
    sTitle: '@',
    sNotificationNumber: '@?' 
  }
};